import { CldImage } from 'next-cloudinary';
import useDimensions from 'react-cool-dimensions';

/* eslint-disable-next-line */
export interface ImageRenderProps {
    fields: {
        title?: string;
        image: {
            fields: {
                file: { url: string };
                altText?: string;
                description?: string;
            };
        };
        description?: string;
    };
}

const ImageRender = ({ fields }: ImageRenderProps) => {
    const { image } = fields;
    const { observe } = useDimensions<HTMLDivElement | null>();

    return (
        <div className="my-16 w-full mx-auto max-w-container">
            <section className="image-container-responsive">
                <div ref={observe}>
                    <CldImage
                        className="image-responsive"
                        fill
                        format="auto" // Automatically use WebP or AVIF based on browser support
                        quality="auto" // Automatically adjust quality based on network and device
                        dpr="auto" // Automatically adjust for device pixel ratio
                        sizes={'100vw'}
                        src={`${image.fields.file.url}`}
                        alt={image.fields.altText || ''}
                        loading="lazy"
                        fetchPriority="auto"
                        placeholder="blur"
                        blurDataURL="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiB2aWV3Qm94PSIwIDAgMTAwIDEwMCI+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0iI2YzZjRmNiIvPjwvc3ZnPg=="
                    />
                    {image.fields.description && (
                        <span className="pb-4 ml-4 font-mono text-sm text-gray-900 xl:ml-0">
                            {image.fields.description}
                        </span>
                    )}
                </div>
            </section>
        </div>
    );
};

export default ImageRender;
